import React, { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { buildShareUrl } from "@/lib/shareUrl";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmailResultsCard = ({ inputs, result }) => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  if (!result?.summary) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      toast.error("Enter a valid email.");
      return;
    }
    setSending(true);
    try {
      const s = result.summary;
      const { data } = await axios.post(`${API}/results/email`, {
        email,
        share_url: buildShareUrl(inputs),
        summary: {
          success_pct: s.success_probability_pct,
          median_final_balance: s.median_final_balance,
          retirement_age: inputs.retirement_age,
          life_expectancy: inputs.life_expectancy,
          annual_withdrawal: inputs.annual_withdrawal,
        },
      });
      setDone(true);
      toast.success(
        data.emailed
          ? "Sent! Check your inbox for your results."
          : "Saved! Your results link is reserved — email delivery is activating shortly."
      );
    } catch {
      toast.error("Could not send — please try again.");
    } finally {
      setSending(false);
    }
  };

  if (done)
    return (
      <div data-testid="email-results-done" className="bg-[#E8F0EB] border border-[#2B5339] rounded-2xl p-5 text-sm text-[#2B5339]">
        ✓ Your results are on their way. Your plan link keeps working forever — no account needed.
      </div>
    );

  return (
    <form
      onSubmit={submit}
      data-testid="email-results-card"
      className="bg-white border border-[#E5E2DC] rounded-2xl p-5 flex flex-wrap items-center gap-3"
    >
      <div className="flex-1 min-w-[220px]">
        <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#2B5339] mb-1 inline-flex items-center gap-1.5">
          <Mail size={11} /> Email me my results
        </div>
        <p className="text-xs text-[#5C6B62]">
          Get this projection + a live link to reopen it anytime. No spam, no account.
        </p>
      </div>
      <input
        data-testid="email-results-input"
        type="email"
        required
        placeholder="you@email.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="bg-[#F9F8F6] border border-[#E5E2DC] rounded-full px-4 py-2 text-sm focus:outline-none focus:border-[#2B5339] w-56"
      />
      <button
        data-testid="email-results-submit"
        type="submit"
        disabled={sending}
        className="inline-flex items-center gap-1.5 bg-[#2B5339] text-white rounded-full px-5 py-2 text-sm hover:bg-[#1E3B28] disabled:opacity-50"
      >
        {sending ? <Loader2 size={13} className="animate-spin" /> : <Mail size={13} />}
        Send
      </button>
    </form>
  );
};

export default EmailResultsCard;
